import { downLoadXlsx } from '@/utils/downloadfile';
import request from '@/utils/request';
// import type { addUserType, UserListParams } from './data.d';

// /* *
//  *
//  * @author whiteshader@163.com
//  * @datetime  2021/09/16
//  *
//  * */

// // 查询用户信息列表
// export async function getUserList(params?: UserListParams) {
//   const queryString = new URLSearchParams(params).toString();
//   return request(`/waterbase/system/user/list?${queryString}`, {
//     data: params,
//     method: 'GET',
//     headers: {
//       'Content-Type': 'application/json;charset=UTF-8',
//     },
//   });
// }

// // 查询用户信息详细
// export function getUser(userId: number) {
//   return request(`/waterbase/system/user/${userId}`, {
//     method: 'GET',
//   });
// }

// // 新增用户信息
// export async function addUser(params: addUserType) {
//   return request('/waterbase/system/user', {
//     method: 'POST',
//     data: params,
//   });
// }

// // 修改用户信息
// export async function updateUser(params: addUserType) {
//   return request('/waterbase/system/user', {
//     method: 'PUT',
//     data: params,
//   });
// }

// // 删除用户信息
// export async function removeUser(ids: string) {
//   return request(`/waterbase/system/user/${ids}`, {
//     method: 'DELETE',
//     headers: {
//       'Content-Type': 'application/json;charset=UTF-8',
//     },
//   });
// }

// // 导出用户信息
// export function exportUser(params?: UserListParams) {
//   return downLoadXlsx(`/waterbase/system/user/export`, { params }, `user_${new Date().getTime()}.xlsx`);
// }

// // 导入用户信息
// export function importUser(data: any) {
//   return request('/system/user/importData?updateSupport=true', {
//     method: 'POST',
//     data,
//   });
// }

// // 重置用户密码
// export function updateUsersPwd(userId: string, password: string) {
//   const data = {
//     userId,
//     password,
//   };
//   return request('/waterbase/system/user/profile/updatePwd', {
//     method: 'put',
//     data,
//   });
// }

// // 修改用户状态
// export function updateUserStatus(userId: string, status: string) {
//   const data = {
//     userId,
//     status,
//   };
//   return request('/waterbase/system/user/changeStatus', {
//     method: 'put',
//     data,
//   });
// }

// // 根据用户编号获取授权角色
// export function getUserAuth(userId: number) {
//   return request(`/waterbase/system/user/authRole/${userId}`, {
//     method: 'GET',
//   });
// }

// // 用户授权角色
// export function updateUserAuth(userId: string, roleIds: string) {
//   const data = {
//     userId,
//     roleIds,
//   };
//   return request('/waterbase/system/user/authRole', {
//     method: 'put',
//     params: data,
//   });
// }

// ------------------------------

// 修改个人信息
export function updateUserProfile(data: API.CurrentUser) {
  return request('/waterbase/system/user/profile', {
    method: 'put',
    data: data,
  });
}

// // 个人密码重置
export function updateUserPwd(oldPassword: string, newPassword: string) {
  const data = {
    oldPassword,
    newPassword,
  };
  return request('/waterbase/system/user/profile/updatePwd', {
    method: 'put',
    params: data,
  });
}

// // 个人头像上传
export function uploadAvatar(data: any) {
  return request('/waterbase/system/user/profile/avatar', {
    method: 'post',
    data: data,
  });
}

// tree树
export function listForTreeAll() {
  return request('/waterbase/system/org/listForTreeAll');
}
// 获取用户列表 —— 接口
export function userList(params: any) {
  return request('/waterbase/system/user/list', {
    method: 'get',
    params,
  });
}
// 新增用户列表 —— 接口
export function addUserList(data: any) {
  return request('/waterbase/system/user', {
    method: 'POST',
    data,
  });
}
// 编辑用户列表 —— 接口
export function editUserList(data: any) {
  return request('/waterbase/system/user', {
    method: 'PUT',
    data,
  });
}
// 删除用户列表 —— 接口
export function deleteUserList(id: string) {
  return request(`/waterbase/system/user/${id}`, {
    method: 'DELETE',
  });
}
// 导出用户列表 —— 接口
export function exportUserList(data: any) {
  return downLoadXlsx(
    `/waterbase/system/user/export`,
    {
      method: 'POST',
      data,
    },
    `user_${new Date().getTime()}.xlsx`
  );
}

// -------------------  编辑页面接口 -----------------------

// 获取角色列表 —— 接口
export function optionselect() {
  return request('/waterbase/system/role/optionselect?flag=0');
}

// 获取机构下拉列表 —— 接口
export function getListSimple() {
  return request('/waterbase/system/org/listForTree?flag=0', {
    method: 'GET',
  });
}

// 获取部门下拉列表 —— 接口
export function getDeptListSimple(orgId: number | string) {
  const params: any = {
    flag: 0,
    orgId,
  };
  return request('/waterbase/system/dept/listForTree', {
    method: 'GET',
    params,
  });
}

// 获取岗位下拉列表 —— 接口
export function getPostListSimple(deptId: number | string) {
  return request('/waterbase/system/post/optionselect', { params: { deptId } });
}

// 重置密码
export function resetPwdHandle(params: any) {
  return request('/waterbase/system/user/resetPwd', {
    method: 'PUT',
    data: {
      ...params,
    },
  });
}
// 获取编辑 —— 详情页
export function getEditDetail(params: number | string) {
  return request(`/waterbase/system/user/${params}`, {
    method: 'GET',
  });
}

// 查看可加入的机构
export function getOrgJoinList(params: number | string) {
  return request(`/waterbase/system/org/listSimpleSearch?searchValue=${params}`, {
    method: 'GET',
  });
}

// 申请加入机构
export function joinOrg(params: number | string) {
  return request(`/waterbase/system/user/profile/apply/${params}`, {
    method: 'POST',
  });
}
